<script>
  import Header from './components/Header.svelte';
  import Body from './components/Body.svelte';
</script>

<div class="uk-width-3-5@l">
  <Header />

  <Body />
</div>
